import { styled } from "@mui/material/styles";
import {
    InternalStandardProps,
    Grid,
    GridProps,
    Box,
} from "@mui/material";

const Root = styled(Grid)({
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

const CommonText = styled("h2")({
    textAlign: "center",
    fontWeight: "200",
    textTransform: "uppercase",
    margin: `4% !important`,
});

const HeadingText = styled(CommonText)(({ theme }) => ({
    color: theme.colors?.red,
}));

const DescriptionText = styled("h3")(({ theme }) => ({
    textAlign: "center",
    fontWeight: "200",
    textTransform: "uppercase",
    margin: `4% !important`,
    color: theme.palette.primary.main,
}));

const BtnWrapper = styled(Box)({
    display: "flex",
    justifyContent: "center",
    margin: `4% !important`,
});

const BtnGoToHome = styled("button")(({ theme }) => ({
    borderRadius: "2em",
    display: "inline-block",
    padding: "0.35em 1.2em",
    border: `0.2px solid ${theme.palette.primary.main}`,
    background: "transparent",
    margin: "0 0.3em 0.3em 0",
    boxSizing: "border-box",
    textDecoration: "none",
    fontFamily: "Roboto,sans-serif",
    fontWeight: "300",
    color: theme.palette.common.black,
    textAlign: "center",
    transition: "all 0.2s",
    cursor: "pointer !important",
    "&:hover": {
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
}));

export interface AppFallBackComponentProps
    extends InternalStandardProps<GridProps> {
    title?: string;
    desc: string;
    routeText: string;
    route: string;
}

export const AppFallBackComponent = (props: AppFallBackComponentProps) => {
    const { className, title, desc, routeText, route, ...rest } = props;

    return (
        <Root container className={className} {...rest}>
            <Grid item xs={12}>
                {title && <HeadingText>{title}</HeadingText>}
                <DescriptionText>{desc}</DescriptionText>
                <BtnWrapper>
                    <BtnGoToHome onClick={() => window.location.replace(route)}>
                        {routeText}
                    </BtnGoToHome>
                </BtnWrapper>
            </Grid>
        </Root>
    );
};
